import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import Store from "logic/local-storage/Store";
import { StatusIcon } from "components/common";
import urlWithAuthParams from "enterprise-integrations/helpers/urlWithAuthParams";
import { ApiRoutes } from "./common/Routes";
import { toO365InputCreateRequest } from "./common/formDataAdapter";
import FormWrap from "../common/FormWrap";
const Container = styled.div(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.variant.darkest.default};
    margin: 25px 0;
    padding: 15px;
    border-radius: 4px;
  `
);
const Subheader = styled.h3`
  margin: 0 0 10px;
`;
const ReviewItems = styled.ul(
  ({ theme }) => css`
    list-style: none;
    margin: 0 0 25px 10px;
    padding: 0;

    li {
      padding: 5px;

      &:nth-of-type(odd) {
        background-color: ${theme.colors.table.row.backgroundStriped};
      }
    }

    strong::after {
      content: ':';
      margin-right: 5px;
    }
  `
);
const StepReview = ({ onSubmit, externalInputSubmit = false }) => {
  var _a, _b, _c;
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const throttleEnabled = !!((_a = formData.o365ThrottleEnabled) == null ? void 0 : _a.value);
  const dropSensitiveDlpLogs = !!formData.o365DropSensitiveDlpLogs.value;
  const storeFullMessage = !!((_b = formData.o365StoreFullMessage) == null ? void 0 : _b.value);
  const timeoutGracePeriodMinutes = ((_c = formData.timeoutGracePeriodMinutes) == null ? void 0 : _c.value) || "5";
  const [saveInput, setSaveInput] = useFetch(
    null,
    (result) => {
      if (result == null ? void 0 : result.id) {
        Store.sessionSet("setup_wizard_input_id", result.id);
      }
      onSubmit();
    },
    "POST",
    toO365InputCreateRequest(formData),
    urlWithAuthParams
  );
  const formError = saveInput.error ? {
    full_message: saveInput.error,
    nice_message: /* @__PURE__ */ React.createElement("span", null, t("common.errors.unable_to_save_input"))
  } : null;
  const handleSubmit = () => {
    if (externalInputSubmit) {
      onSubmit(formData);
      return;
    }
    setSaveInput(ApiRoutes.INTEGRATIONS.O365.SAVE_INPUT);
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.save_and_start_input"),
      loading: saveInput.loading,
      error: formError,
      description: t("o365.review.description")
    },
    /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Subheader, null, t("common.steps.input_configuration")), /* @__PURE__ */ React.createElement(ReviewItems, null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("common.fields.name")), /* @__PURE__ */ React.createElement("span", null, formData.o365Name.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("o365.review.subscribed_to")), /* @__PURE__ */ React.createElement("span", null, formData.contents.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("o365.review.subscription_plan")), /* @__PURE__ */ React.createElement("span", null, formData.subscriptionType.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("o365.review.polling_interval_minutes")), /* @__PURE__ */ React.createElement("span", null, formData.pollingInterval.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("o365.review.timeout_grace_period")), /* @__PURE__ */ React.createElement("span", null, timeoutGracePeriodMinutes)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("common.fields.enable_throttling")), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StatusIcon, { active: throttleEnabled }))), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("o365.review.drop_sensitive_dlp_logs")), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StatusIcon, { active: dropSensitiveDlpLogs }))), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, t("common.fields.store_full_message")), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StatusIcon, { active: storeFullMessage })))))
  );
};
export default StepReview;
